// Contract 29 §15.2 — the workspace-attribute WRITE seam.
//
// Onboarding step 2 writes 4 attribute keys, but 29's boundary rule allows only 06/07/11/12
// imports and 07 publishes reads only (`getAttribute` / `refreshAttributes`). The write primitive
// lives in 22 (`SaveAttributeFlow`, whose own R8 note names this onboarding call site). Rather
// than import 22 — which the `boundaries` lint rejects and which would create the 22↔29 cycle
// §4 exists to prevent — the composition root injects the writer, exactly as it injects the
// Get Started settings contribution and `configureDateRange`'s workspace default.

export interface WorkspaceAttributeWrite {
  key: string
  value: unknown
  /** The existing row id; `null` when the row does not exist yet (drives create-vs-update). */
  attributeId: string | number | null
  /** Write to a workspace other than the selected one — onboarding creates it mid-flow. */
  workspaceId?: number | string
}

export type WorkspaceAttributeWriter = (write: WorkspaceAttributeWrite) => Promise<void>

let writer: WorkspaceAttributeWriter | null = null

/** Install the one attribute writer. Re-installing the same function is a safe no-op. */
export function registerWorkspaceAttributeWriter(next: WorkspaceAttributeWriter): void {
  if (writer === next) return
  if (writer) throw new Error('[global-surface] a workspace attribute writer is already registered')
  writer = next
}

/**
 * The installed writer, or `null` before composition ran.
 *
 * A `null` writer is a real pre-cutover state, not an error: the caller degrades to writing only
 * the settings half of step 2 rather than throwing inside a wizard the user cannot leave.
 */
export function workspaceAttributeWriter(): WorkspaceAttributeWriter | null {
  return writer
}

/** Test isolation only. Product registrations are static for the app lifetime. */
export function resetWorkspaceAttributeWriter(): void {
  writer = null
}
